import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResourceService } from '../../../common/resource.service';
import { UnidadeGestora } from './unidade-gestora';
import { UnidadeGestoraSerializer } from './unidade-gestora.serializer';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { Entidade } from '../entidade/entidade';

@Injectable({
  providedIn: 'root'
})
export class UnidadeGestoraService extends ResourceService<UnidadeGestora>{
  
  urlAdm: string = environment.apiAdmin;
  
  constructor(http:HttpClient) {
    super(http,'unidade-gestora', new UnidadeGestoraSerializer(UnidadeGestora));
  }

  buscarTodos():Observable<UnidadeGestora[]>{
    return this.httpClient.get<UnidadeGestora[]>(`${this.urlAdm}/${this.endpoint}/todos`).pipe(
      map(data => this.convertData(data)),
      take(1)
    );
  }

  buscarTodosPorEntidade(entidade: Entidade):Observable<UnidadeGestora[]>{
    return this.httpClient.get<UnidadeGestora[]>(`${this.urlAdm}/${this.endpoint}/entidade/${entidade.id}`).pipe(
      map(data => this.convertData(data)),
      take(1)
    );
  }
}
